import { render } from "./storeList.vue?vue&type=template&id=3616684c&scoped=true"
import script from "./storeList.vue?vue&type=script&lang=js"
export * from "./storeList.vue?vue&type=script&lang=js"

import "./storeList.vue?vue&type=style&index=0&id=3616684c&lang=scss&scoped=true"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3616684c"]])

export default __exports__